import { render, staticRenderFns } from "./reward-descript.vue?vue&type=template&id=a5b9b89c&scoped=true&"
import script from "./reward-descript.vue?vue&type=script&lang=js&"
export * from "./reward-descript.vue?vue&type=script&lang=js&"
import style0 from "./reward-descript.vue?vue&type=style&index=0&id=a5b9b89c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b9b89c",
  null
  
)

export default component.exports